import AutoPlayVideo from "./Autoplayvideo";
import Letstalk from "../header/LetsTalkHero";

export default function GrowthPartner() {
  return (
    // Mobile: video on top, text below, height follows content.
    // md and up: text panel on the left over a full-bleed video.
    <section className="relative isolate flex flex-col overflow-hidden md:min-h-[640px] md:flex-row lg:min-h-[760px] 2xl:min-h-[850px]">
      {/* Video */}
      <div className="relative aspect-video w-full bg-primary md:absolute md:inset-0 md:aspect-auto md:h-full">
        <AutoPlayVideo
          src="https://res.cloudinary.com/daybtdlim/video/upload/v1792765010/t2.mp4"
          poster="/hero.avif"
          className="h-full w-full object-cover"
        />
      </div>

      {/* Text panel */}
      <div className="relative z-10 flex w-full flex-col justify-center bg-primary/95 px-5 py-10 sm:px-10 sm:py-12 md:max-w-sm md:px-10 lg:max-w-md lg:px-14 xl:max-w-xl xl:px-18 ">
        <h2 className="text-balance text-3xl font-bold leading-tight text-white  lg:text-4xl 2xl:text-5xl">
          Your Digital Growth Partner
        </h2>

        <p className="py-5 text-base font-medium leading-relaxed text-white sm:py-6  lg:py-8 lg:text-xl ">
          Everything your business needs to grow online, from high-performance
          websites to secure hosting, maintenance, consultation, and ongoing
          support. Available with flexible one-time or annual plans.
        </p>

        <div className="self-start">
          <Letstalk />
        </div>
      </div>
    </section>
  );
}